    import React, { Component,Fragment } from 'react';
    import PropTypes from "prop-types";
    import { Link } from 'react-router-dom';
    import {BeatLoader} from 'react-spinners';
    import NotificationSystem from 'react-notification-system';
    import {get, postWithHeaders,putWithHeadersResponse} from "../../../server/actions";
    import {_addNotification, _addNotificationError,getGradeIndexValue, isRegularLunchOrderType, 
        standardDateFormat,convertTwoDecimalPoint,getGradeIndex,isInt,getSchoolGrades, groupBy,} from '../../../server/util';
    class SessionRecord extends Component {
        constructor(props){
            super(props);
            this.state={
                loading:false,
                recId:0,
                rec:{},
                sessionList:[],
                gradeList:[],
                assignedList:[]
            }
        }
        componentDidMount=()=>{
            const _grades= getSchoolGrades(undefined,false);
            this._notificationSystem = this.refs.notificationSystem;
            const { id } = this.context.router.route.match.params;
            const {schoolId, rec, assignedGrades, sessionList}=this.context.router.route.location.state;
            _grades.map(g=>{
                if(assignedGrades.includes(g.value)){
                    g.disabled=true;
                    g.checked=true;
                }else if(((rec||{}).grades||[]).includes(g.value)){
                    g.disabled=false;
                    g.checked=true;
                }else{
                    g.disabled=false;
                    g.checked=false;
                }
            })

            this.setState({recId:id||0, rec:rec||{}, gradeList:_grades, assignedList:assignedGrades||[], sessionList:sessionList});
        }
         onCheckedChangeGrades=(e)=>{
            const {gradeList}=this.state;
            const idx= gradeList.findIndex((item,i)=>{                
                return item.value==e.target.value
            }); 
            if(idx!==-1){
                gradeList[idx].checked=e.target.checked;
            }
            this.setState({gradeList:gradeList});
        }
        saveSession=()=>{
            const {recId,rec,gradeList,sessionList}=this.state;
            const schoolId=sessionStorage.getItem('SchoolId');
            if(((rec.session||'').trim()).length<=0){
                _addNotificationError('Please enter session name',this)
                return false;
            }
            const sessionNameExists=sessionList.filter(s=>{
                const rId=parseInt(s._links.self.href.split('/').pop());
                return recId!=rId
            }).some(s=>{                
                return s.session===rec.session 
            })
            if(sessionNameExists){
                _addNotificationError('Session name already exist. Please try other name',this)
                return false;
            }
            if(! gradeList.some(item=>{
                return item.checked && !item.disabled
            })){
                _addNotificationError('Please select grade',this)
                return false;
            }
            const requestBody={
                "mealSchoolId": schoolId,
                "session": rec.session,
                "grades": (gradeList.filter(grade=>{
                    return grade.checked && !grade.disabled
                }).map(g=>{
                  return g.value
                }))
            }
            if(recId<=0){
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                };
                this.setState({loading: true});
                postWithHeaders(`/schoolSessions?access_token=`,JSON.stringify(requestBody),headers).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    _addNotification('Record saved successfully.', this);
                    this.setState({loading: false});
                    setTimeout(() => {                       
                        this.context.router.history.push('/schoolAdmin/lunchSessions');
                    }, 3000);
                }).catch(
                    (error) => {
                        this.setState({loading: false});
                        _addNotificationError('Could not saved session data.', this);
                    }
                )
            }else{
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                };
                this.setState({loading: true});
                putWithHeadersResponse('/schoolSessions/'+recId+'/?access_token=',JSON.stringify(requestBody),headers)
                    .then((response)=>{
                        if (!response.ok) {
                            throw Error(response.statusText);
                        }
                        return response;
                    })
                    .then((data)=>{
                        _addNotification('Successfully updated session data.', this);
                        this.setState({loading: false});
                        setTimeout(() => {                       
                            this.context.router.history.push('/schoolAdmin/lunchSessions');
                        }, 3000);
                    }).catch(error=>{
                        this.setState({loading: false});
                        _addNotificationError('Could not updated session data.', this);
                    });
                }
            }
        render() {
            const {recId, rec, gradeList}=this.state;
            return (
                <Fragment>
                    <NotificationSystem ref="notificationSystem"/>
                    <section className=" full-width clearfix">
                        <div className='sweet-loading'
                            style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>

                        <div className="container">
                            <div className="row">
                                <div className="sectionTitle">
                                    <div className="col-md-2">
                                        <h2><span>{recId>0?"Edit Lunch Session":"New Lunch Session"}</span></h2>
                                    </div>
                                    <div className="col-md-10 text-right">
                                    </div>                                
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="panel panel-primary">
                                        <div className="panel-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <form>
                                                        <div className="form-group">
                                                            <label htmlFor="session">Session Name*:</label>
                                                            <input type="text" name="session" value={rec.session} className="form-control" id="session" onChange={(e)=>{
                                                                const rec={...rec};
                                                                rec[e.target.name]=e.target.value;
                                                                this.setState({rec});
                                                            }} />
                                                        </div>
                                                        <div className="form-group">
                                                            <div className=" createmenu-grade-group" style={{display:'block' }}>
                                                                <label className="custom-label text-left" style={{margin: '18px 0px'}}>Select Grades*:</label>
                                                                <div className=" input-group">
                                                                    <div class="styled-input-container styled-input--square">                                                    
                                                                    {
                                                                        gradeList.map(grade => {
                                                                            return (
                                                                                <div className="styled-input-single col-md-2 pull-left"
                                                                                    style={{margin: '-15px 8px'}}>
                                                                                    <input type="checkbox" name="grades"
                                                                                        onChange={(e)=>{
                                                                                            this.onCheckedChangeGrades(e)
                                                                                        }}
                                                                                        id={grade.label} value={grade.value} 
                                                                                        checked={grade.checked?true:false}
                                                                                        disabled={grade.disabled}
                                                                                        />
                                                                                    <label className={ grade.disabled? 'disable-checkbox':''}  htmlFor={grade.label}>{grade.label}</label>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="col-md-12 text-right ">
                                                            <button type="button" class="btn btn-success button-sm add-btn-sm" onClick={()=>{
                                                                this.saveSession()
                                                            }}>Save</button>
                                                            <button type="button" class="btn btn-danger button-sm add-btn-sm" onClick={(e)=>{
                                                                this.context.router.history.push('/schoolAdmin/lunchSessions')
                                                            }}>Cancel</button>

                                                            </div>
                                                        </div>
                                                        
                                                    </form>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>                
                </Fragment>
            );
        }
    }
    SessionRecord.contextTypes = {
        router: PropTypes.object.isRequired
    };
    export default SessionRecord;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/LunchSessions/sessionRecord.jsx